import React from 'react'
import Icon from 'components/Icon'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'

const TextArea = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled } = attribute
  const { limit } = options || {}
  const { formatMessage } = useIntl()

  return (
    <fieldset className="space-y-1">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <textarea
        type="text"
        placeholder={options?.placeholder || formatMessage(messages.placeholder, { name: name.toLowerCase() })}
        disabled={disabled}
        value={state || ''}
        onChange={({ target: { value } }) => {
          if (limit && value.length == limit) {
            return
          }

          onChange(value)
        }}
        className={`w-full p-2 px-3 focus:border-primary transition duration-200 border border-gray-300 ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />

      { limit && state &&
        <span className="text-xs font-medium text-gray-500 mt-1">
          <FormattedMessage {...messages.charactersLeft } values={{ charsLeft: limit - state.length }} />
        </span>
      }
    </fieldset>
  )
}

export default TextArea
